import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampaignScheduleStatus } from '@vendasta/campaigns';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'crm-recipient-campaign-status',
  imports: [CommonModule, GalaxyBadgeModule],
  templateUrl: './recipient-campaign-status.component.html',
  styleUrl: './recipient-campaign-status.component.scss',
})
export class RecipientCampaignStatusComponent implements OnChanges {
  status: string;
  color: string;

  @Input() recipientCampaignStatus: CampaignScheduleStatus;

  constructor(private translate: TranslateService) {}

  ngOnChanges(): void {
    switch (this.recipientCampaignStatus) {
      case CampaignScheduleStatus.CAMPAIGN_SCHEDULE_STATUS_ACTIVE:
        this.status = this.translate.instant('ASSOCIATIONS.CAMPAIGNS.STATUS.ONGOING');
        this.color = 'blue';
        break;
      case CampaignScheduleStatus.CAMPAIGN_SCHEDULE_STATUS_STOPPED:
        this.status = this.translate.instant('ASSOCIATIONS.CAMPAIGNS.STATUS.PAUSED');
        this.color = 'gray';
        break;
      case CampaignScheduleStatus.CAMPAIGN_SCHEDULE_STATUS_COMPLETED:
        this.status = this.translate.instant('ASSOCIATIONS.CAMPAIGNS.STATUS.COMPLETED');
        this.color = 'green';
        break;
    }
  }
}
